module.exports = __webpack_public_path__ + "static/media/invoices.8d21335f.svg";